import { render, staticRenderFns } from "./stockByProductionYearsTable.vue?vue&type=template&id=55451554&scoped=true&"
import script from "./stockByProductionYearsTable.vue?vue&type=script&lang=js&"
export * from "./stockByProductionYearsTable.vue?vue&type=script&lang=js&"
import style0 from "./stockByProductionYearsTable.vue?vue&type=style&index=0&id=55451554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55451554",
  null
  
)

export default component.exports